import { useContext } from 'react'
import { SaveQueueContext } from '../context/SaveQueueContextTypes'

export const useSaveQueue = () => {
  const context = useContext(SaveQueueContext)
  if (!context) {
    throw new Error('useSaveQueue must be used within SaveQueueProvider')
  }
  return context
}
